import { WebAnalyticsEventName } from 'hydra-data-types';

/** Currency is an arbitrary string and not intended to be dynamic based on the customers actual currency. */
const FACEBOOK_VALUE_CURRENCY = 'USD';

type FacebookValueEventConfig = {
  /**
   * Value is an arbitrary number that increases the further the user reaches in the flow.
   * It is not dynamic and does not reflect the actual price the user will pay.
   */
  value: number;
  currency: typeof FACEBOOK_VALUE_CURRENCY;
};

/**
 * Events that have facebook value properties added, as we can no longer track purchase events. See GR-2427.
 */
export const FACEBOOK_VALUE_EVENTS: Partial<
  Record<WebAnalyticsEventName, FacebookValueEventConfig>
> = {
  [WebAnalyticsEventName.o_flow_entered]: {
    value: 25,
    currency: FACEBOOK_VALUE_CURRENCY,
  },
  [WebAnalyticsEventName.a_signup_succeeded]: {
    value: 50,
    currency: FACEBOOK_VALUE_CURRENCY,
  },
  [WebAnalyticsEventName.o_payment_started]: {
    value: 100,
    currency: FACEBOOK_VALUE_CURRENCY,
  },
  [WebAnalyticsEventName.o_download_app_screen_viewed]: {
    value: 250,
    currency: FACEBOOK_VALUE_CURRENCY,
  },
};

export function attachFacebookValueEventProperties<Properties extends object | undefined>(
  event: WebAnalyticsEventName,
  properties: Properties
): Properties {
  return { ...properties, ...FACEBOOK_VALUE_EVENTS[event] };
}
